import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Mankato",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Mankato Minnesota cityscape with Minnesota State University campus, Minnesota River valley, downtown historic district, residential neighborhoods with mature trees, south central Minnesota rolling hills, warm golden hour lighting, professional cityscape photography, no readable text or signs",
  heroImageSeq: "mankato-mn-hero-2026",
  heroDescription:
    "Business trip to Europe in two weeks? Student study abroad at MSU Mankato? Family vacation to Mexico and your passport just expired? Need a first-time passport for a new job? We help Mankato residents — from MSU Mankato students and faculty to south central Minnesota families and healthcare professionals — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.1635; -93.9994",
  geoPlacename: "Mankato, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/mankato/",
  localAreaTitle: "Serving Mankato & South Central Minnesota",
  localAreaText: [
    "Mankato, Minnesota is a thriving regional hub in the heart of south central Minnesota, where the Minnesota River winds through the valley below. As the home of Minnesota State University, Mankato — the state's second-largest university — the city has a vibrant, youthful energy that drives a significant amount of international travel. Study abroad programs, international student exchanges, faculty research trips, and conference attendance are all part of the university's global engagement.",
    "Mankato is also a major healthcare center for the region. The Mayo Clinic Health System and other medical facilities serve a large catchment area, creating a professional population that travels for medical conferences, training, and international medical missions. When a conference in London, a training in Singapore, or a medical mission in Central America arises, the need for an expedited passport is immediate.",
    "The city's economy extends beyond education and healthcare. Mankato is a regional center for agriculture, manufacturing, and retail, serving communities across a multi-county area. The River Hills Mall, downtown Mankato, and the growing commercial areas along Highway 14 and Madison Avenue create a prosperous community where international travel is a natural part of the lifestyle.",
    "Mankato's residential neighborhoods are diverse, from historic homes near the university to newer developments in the city's north and east. Families in these communities are active travelers — spring break trips, summer European tours, and holiday visits to relatives abroad are all common. The city's strong schools and community programs also generate travel for sports, academics, and cultural exchanges.",
  ],
  nearbyCities: [
    { name: "Mankato", zips: "56001, 56002, 56003" },
    { name: "North Mankato", zips: "56003" },
    { name: "St. Peter", zips: "56082" },
    { name: "New Ulm", zips: "56073" },
    { name: "Owatonna", zips: "55060" },
    { name: "Faribault", zips: "55021" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your dorm, home, or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from Mankato to send your documents directly to us.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Mankato & South Central Minnesota Coverage",
  serviceAreaDescription: "Serving Blue Earth County and south central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Mankato, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Mankato can take 2–6 months. For MSU Mankato students with study abroad deadlines and healthcare professionals with conference travel, that timeline is not viable.",
    },
    {
      q: "Can MSU Mankato students get an expedited passport for study abroad?",
      a: "Absolutely. Study abroad programs are one of our most common requests from Mankato. Many students receive their program acceptance with only 2–4 weeks before departure. We regularly process expedited first-time passports and renewals for MSU Mankato students on compressed timelines.",
    },
    {
      q: "What if my passport expires before a medical conference?",
      a: "Healthcare professionals in Mankato frequently attend international conferences with short notice. If your passport is expiring or expired, we can expedite your renewal so you do not miss critical professional development opportunities. Most conference registrations are non-refundable.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Mankato travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Mankato. Start your order online, follow the checklist, and ship your documents overnight from anywhere in south central Minnesota.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "MSU Mankato Student",
      rating: 5,
      text: "I got accepted into a study abroad program in Florence with only three weeks before departure. My passport had expired. Fast Passport Center processed my renewal in five business days. I made my program and had an incredible semester. Their document review was incredibly thorough.",
      service: "Passport Renewal",
    },
    {
      name: "Dr. James Patterson",
      location: "Mankato, MN",
      rating: 5,
      text: "I received an invitation to present at a medical conference in London with two weeks notice. My passport was within two months of expiration. Fast Passport Center processed my renewal in four business days. I presented at the conference and it was a great success. Professional service.",
      service: "Emergency Renewal",
    },
    {
      name: "The Anderson Family",
      location: "Mankato, MN",
      rating: 5,
      text: "We planned a family trip to Costa Rica and discovered our son's passport had expired three weeks before departure. Fast Passport Center processed his child passport in five business days. We made our trip and had an amazing time. Thank you for the excellent service.",
      service: "Child Passport",
    },
  ],
  nearbyLinks: [
    { name: "St. Cloud", href: "/cities/st-cloud" },
    { name: "Owatonna", href: "/cities/owatonna" },
    { name: "Faribault", href: "/cities/faribault" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "Rochester", href: "/cities/rochester-mn" },
    { name: "Northfield", href: "/cities/northfield" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Mankato",
  introDescription: "Fast, reliable passport processing for Mankato and south central Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Mankato and south central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Mankato Post Office",
      address: "201 E Hickory St, Mankato, MN 56001",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(507) 387-5532",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Mankato and Blue Earth County.",
    },
    {
      name: "North Mankato Post Office",
      address: "1615 Commerce Dr, North Mankato, MN 56003",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 625-2316",
      notes: "Convenient for North Mankato and Nicollet County residents. Passport photos available. Call ahead for appointment.",
    },
    {
      name: "St. Peter Post Office",
      address: "220 S Front St, St. Peter, MN 56082",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 931-4520",
      notes: "Serves St. Peter and Nicollet County residents. Call ahead for appointment availability.",
    },
    {
      name: "New Ulm Post Office",
      address: "201 N Broadway, New Ulm, MN 56073",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 354-3021",
      notes: "Serves New Ulm and Brown County residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Mankato", address: "1940 Adams St, Mankato, MN 56001", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Mankato", address: "1850 Madison Ave, Mankato, MN 56001", hours: "Call for hours" },
    { name: "The UPS Store — Mankato", address: "1901 Madison Ave, Mankato, MN 56001", hours: "Call for hours" },
    { name: "Walgreens — North Mankato", address: "1730 Commerce Dr, North Mankato, MN 56003", hours: "Call for hours" },
    { name: "CVS Pharmacy — St. Peter", address: "700 S Front St, St. Peter, MN 56082", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Mankato", address: "1850 Madison Ave, Mankato, MN 56001", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Mankato",
      address: "Mankato area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Blue Earth County Service Center",
      address: "Mankato, MN 56001",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "County services. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MKT",
      name: "Mankato Regional Airport",
      distance: "About 5 miles from Mankato — 10 minutes by car",
      address: "1715 Airport Rd, Mankato, MN 56001",
      note: "Regional airport for general aviation. No commercial passenger service. Mankato residents typically drive to MSP for commercial flights.",
      flightUrl: "https://www.mankatoairport.com/",
      flightLabel: "Mankato Airport Info",
      featured: false,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 85 miles from Mankato — 1.5 hours by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for Mankato residents. Direct international flights to Europe, Asia, and Latin America. Many Mankato travelers drive to MSP for international departures.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
  ],
  travelCards: [
    {
      title: "MSU Mankato Study Abroad Programs",
      subtitle: "International education opportunities for students and faculty",
      content:
        "Minnesota State University, Mankato runs active study abroad programs across Europe, Asia, and Latin America. Students frequently receive program acceptance with 2–4 weeks before departure. Spring and fall semester programs, plus summer sessions, create consistent seasonal demand for passport services.",
      tip: "MSU Mankato students should check passport expiration at least 6 months before any study abroad program. Most countries require 6 months validity beyond your return date.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Healthcare Conference Travel",
      subtitle: "Medical professionals attending international conferences and training",
      content:
        "Mankato's healthcare community is active in international medicine. The Mayo Clinic Health System and other medical facilities send professionals to conferences in Europe, Asia, and Latin America. Medical mission trips to Central America and Africa are also common. Conference schedules are typically fixed and non-negotiable.",
      tip: "Healthcare professionals should check passport expiration at least 6 months before any conference registration. Conference fees are often non-refundable.",
      icon: "ri-hospital-line",
    },
    {
      title: "South Central Minnesota Business Travel",
      subtitle: "Regional professionals with international clients and partnerships",
      content:
        "Mankato's business community includes manufacturing, agriculture, and technology companies with international clients. These professionals often travel for business development, client meetings, and trade shows. Business travel frequently has 2–3 weeks notice.",
      tip: "South central Minnesota professionals should check passport expiration quarterly. Set calendar reminders. Business travel often has unpredictable lead times.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Family & Leisure Travel",
      subtitle: "Spring break, summer vacations, and holiday trips from the Minnesota River Valley",
      content:
        "Mankato families are active travelers. Spring break trips to Mexico, summer vacations in Europe, and winter cruises to the Caribbean are common. The city's strong middle-class population and university community create consistent demand for family passport services.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months before any planned travel.",
      icon: "ri-parent-line",
    },
  ],
  destinations: [
    {
      name: "Italy",
      context: "Florence, Rome, and study abroad programs through MSU Mankato",
      urgency: "Study abroad and academic exchange programs have fixed start dates",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Cancun, Puerto Vallarta, and Cabo for spring break and family vacations",
      urgency: "Spring break trips and resort packages are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London, Edinburgh, and medical conferences",
      urgency: "Conference and event schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Berlin, Munich, and Frankfurt for business and medical conferences",
      urgency: "Conference and event schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises, all-inclusive resorts, and island hopping",
      urgency: "Cruise departures and resort packages are often booked 3–6 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Spain",
      context: "Barcelona, Madrid, and study abroad programs",
      urgency: "Study abroad and academic exchange programs have fixed start dates",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "35%",
      label: "of Mankato expedited requests are study abroad or academic travel with 2–4 weeks notice",
    },
    {
      stat: "2–4 Weeks",
      label: "average notice Mankato travelers have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and study abroad coincide",
    },
    {
      stat: "72 Hours",
      label: "shortest emergency turnaround we have accommodated for a Mankato healthcare professional",
    },
  ],
};

export default function MankatoPage() {
  return <CityPage data={data} />;
}